module.exports = __webpack_public_path__ + "static/media/logo_comune.aa9a91c4.webp";